export const en = {
  faq: "FAQs",
  desc: "Find an answer here or contact us to get the help you need",
};

export const ar = {
  faq: "اسئلة و اجوبة",
  desc: "اعثر على إجابة هنا أو اتصل بنا للحصول على المساعدة التي تحتاجها",
};
